import React from "react";

// Dynamically import logos
const importAll = (r) => r.keys().map(r);

// Load all images from client-logos folder
const logos = importAll(
  require.context("../assets/images/clientlogos", false, /\.(png|jpe?g|svg)$/)
);

// Utility to split logos into two rows
const splitLogos = (logos) => {
  const mid = Math.ceil(logos.length / 2);
  return [logos.slice(0, mid), logos.slice(mid)];
};

const ClientLogoSlider = () => {
  const [topRow, bottomRow] = splitLogos(logos);

  return (
    <div className="overflow-hidden bg-light py-5">
      <div className="slider-container">
        {/* Top Row */}
        <div className="d-flex align-items-center slider-content">
          {topRow.map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Client ${index + 1}`}
              className="mx-4"
              style={{ height: "50px", objectFit: "contain" }}
            />
          ))}
          {topRow.map((logo, index) => (
            <img
              key={"dup-top-" + index}
              src={logo}
              alt={`Client ${index + 1}`}
              className="mx-4"
              style={{ height: "50px", objectFit: "contain" }}
            />
          ))}
        </div>

        {/* Spacer between rows */}
        <div style={{ height: "60px" }}></div>

        {/* Bottom Row */}
        <div className="d-flex align-items-center slider-content-reverse">
          {bottomRow.map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Client ${index + 1}`}
              className="mx-4"
              style={{ height: "50px", objectFit: "contain" }}
            />
          ))}
          {bottomRow.map((logo, index) => (
            <img
              key={"dup-bottom-" + index}
              src={logo}
              alt={`Client ${index + 1}`}
              className="mx-4"
              style={{ height: "50px", objectFit: "contain" }}
            />
          ))}
        </div>
      </div>

      {/* CSS Animations */}
      <style>{`
        .slider-container {
          overflow: hidden;
          white-space: nowrap;
        }

        .slider-content {
          animation: slide-left 20s linear infinite;
        }

        .slider-content-reverse {
          animation: slide-right 25s linear infinite; /* Slightly slower */
        }

        .slider-container:hover .slider-content,
        .slider-container:hover .slider-content-reverse {
          animation-play-state: paused;
        }

        @keyframes slide-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @keyframes slide-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default ClientLogoSlider;
